export enum ListDnDTypes {
  LIST_ORDER = "order_list_view",
  LIST_RESIZE = "resize_list_view",
  DRAWER_ORDER = "order_drawer",
}
